import { cva } from 'class-variance-authority';

export const cvaBackLink = cva([
  'BackLinkStyles-cvaBackLink',
  'fixed top-0 z-20',
  'flex items-center gap-0.8',
  'w-full',
  'text-cWhite text-l-b bg-cBlack',
  'py-1.4',
]);
